(function ($, site, generic, google, addthisevent, tms_page_data) {
  'use strict';

  var settings = Drupal.settings.globals_variables || {};
  var appt_book_now = settings.appt_book_now || 0;

  site.locator = site.locator || {};
  site.locator.ui = site.locator.ui || {};
  site.locator.data = site.locator.data || {};
  site.locator.geocoder = site.locator.geocoder || {};
  site.locator.map = null; // Google map object
  site.locator.mapDir = null; // Google map object
  site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
  site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
  site.locator.resultData = {}; // contains results from doors query.
  site.locator.resultData.results = []; // contains ordered results from doors query.
  site.locator.infoWindow = null; // google.maps.InfoWindow object
  site.locator.infoWindowDir = null; // google.maps.InfoWindow object
  site.locator.queryFields = [
    'DOOR_ID',
    'DOORNAME',
    'EVENT_NAME',
    'EVENT_START_DATE',
    'EVENT_END_DATE',
    'EVENT_IMAGE',
    'EVENT_FEATURES',
    'EVENT_TIMES',
    'SERVICES',
    'STORE_HOURS',
    'ADDRESS',
    'ADDRESS2',
    'STATE_OR_PROVINCE',
    'CITY',
    'REGION',
    'COUNTRY',
    'ZIP_OR_POSTAL',
    'PHONE1',
    'STORE_TYPE',
    'LONGITUDE',
    'LATITUDE'
  ].join(', ');
  site.locator.queryFields = [
    'DOOR_ID',
    'SALON_ID',
    'ACTUAL_DOORNAME',
    'ACTUAL_ADDRESS',
    'ACTUAL_ADDRESS2',
    'ACTUAL_CITY',
    'STORE_TYPE',
    'STATE',
    'ZIP',
    'DOORNAME',
    'ADDRESS',
    'ADDRESS2',
    'CITY',
    'STATE_OR_PROVINCE',
    'ZIP_OR_POSTAL',
    'COUNTRY',
    'PHONE1',
    'CLASSIFICATION',
    'IS_SALON',
    'IS_LIFESTYLE_SALON',
    'IS_INSTITUTE',
    'IS_FAMILY_SALON',
    'HAS_MENS_BARBERING',
    'IS_CONCEPT_SALON',
    'IS_STORE',
    'HAS_EXCLUSIVE_HAIR_COLOR',
    'HAS_PURE_PRIVILEGE',
    'HAS_PERSONAL_BLENDS',
    'HAS_GIFT_CARDS',
    'HAS_PAGE',
    'HAS_SPA_SERVICES',
    'IS_GREEN_SALON',
    'HAS_RITUALS',
    'DO_NOT_REFER',
    'HAS_EVENTS',
    'LONGITUDE',
    'LATITUDE',
    'LOCATION',
    'WEBURL',
    'EMAILADDRESS',
    'APPT_URL'
  ].join(', ');

  site.locator.directionsDisplay = null; // google.maps.DirectionsRenderer object
  site.locator.markerCounter = 0;
  site.locator.travelMode = 'DRIVING';
  site.locator.defaultCountries = '';
  site.locator.defaultDistance = 50;
  site.locator.queryArgs = '';
  site.locator.isIntlSearch = false;
  site.locator.lastSearchContext = null;
  site.locator.isState = false;
  site.locator.state = '';
  site.locator.locationData = site.locator.locationData || {};

  // Toggle footer sticky position based on store locator results state.
  site.locator.toggleFooterPosition = function (hasResults) {
    var $footerSticky = $('.footer--sticky');
    $footerSticky.toggleClass('is-static', hasResults);
  };

  site.locator.ui.getRBs = function () {
    site.locator.rb = {
      view_details: 'view details', // rb.get("view_details"),
      store: 'store', // rb.get("store"),
      address: 'address', // rb.get("address"),
      phone: 'phone', // rb.get("phone"),
      event_js: 'event js', // rb.get("event_js"),
      search_results: 'search results', // rb.get("search_results"),
      no_criteria: 'no criteria', // rb.get("no_criteria"),
      search_error: 'error' // rb.get("search_error")
    };
  };

  site.locator.getDomNodes = function () {
    var $wrapper = $('.js-store-locator');

    site.locator.nodes = {
      container: $wrapper,
      storesContainer: $('.js-store-locator__stores', $wrapper),
      staticDefaultContentArea: $('.js-store-locator-default', $wrapper),
      bodyContainer: $('.js-store-locator-body', $wrapper),
      moreResultsContainer: $('.js-more-results-container', $wrapper),
      moreResultsButton: $('.js-more-results.button', $wrapper),
      storeLocatorHero: $('.js-site.locator.nodes.storeLocatorHerostore-locator__hero', $wrapper),
      heroContainer: $('.js-store-locator__hero-container', $wrapper),
      // prepending 'select' to the beginning of the following selector, so that it grabs ONLY the actual select element
      countryMenu: $('select.js-country', $wrapper),
      localcountryMenu: $('.js-local-country', $wrapper),
      cityMenuIntl: $('.js-city-intl', $wrapper), // how is this different from cityMenu
      stateMenu: $('.js-store-search-controls .js-state', $wrapper),
      cityMenu: $('.js-store-search-controls .js-city', $wrapper),
      doorMenu: $('.js-store-search-controls .js-door', $wrapper),
      doorRows: $('.js-door-row', $wrapper),
      doorWithEventRows: $('.js-door-row', $wrapper),
      doorWithoutEventRows: $('.js-door-row', $wrapper),
      searchInput: $('.js-search', $wrapper),
      selectText: $('.js-locator-select', $wrapper),
      distanceMenu: $('select.js-distance', $wrapper),
      searchBtn: $('.js-search-submit', $wrapper),
      searchAltTxt: $('.js-search-alternative-text', $wrapper),
      searchBtnGeo: $('.js-geo-search', $wrapper),
      searchBtnIntl: $('.js-search-submit-intl', $wrapper),
      toggleMapBtn: $('.js-store-locator__toggle-map-btn', $wrapper),
      searchPanel: $('.js-store-search-controls', $wrapper),
      landingPanel: $('.js-locator_landing', $wrapper),
      mapPanel: $('js.locations-map-panel', $wrapper),
      map: $('.js-map-canvas', $wrapper),
      mapContainer: $('.js-map-canvas-container', $wrapper),
      resultsContainer: $('.js-locator-results-container', $wrapper),
      storeResults: $('.js-store-results', $wrapper),
      // eventResults             : $('.js-event-results', $wrapper),
      locatorErrors: $('.js-locator-error-messages', $wrapper),
      locatorErrorsIntl: $('.js-locator-error-messages-intl', $wrapper),
      dirErrors: $('.js-directions-form-errors', $wrapper),
      dirAddrInput: $('.js-directions-form-address', $wrapper),
      dirCityInput: $('.js-directions-form-city', $wrapper),
      dirStateMenuContainer: $('.js-directions-state-container', $wrapper),
      dirStateMenu: $('.js-directions-form-state', $wrapper),
      dirCountryMenu: $('.js-directions-form-country', $wrapper),
      dirDoorInput: $('.js-directions-form-door', $wrapper),
      dirSubmit: $('.js-directions-submit', $wrapper),
      dirForm: $('.js-directions-form', $wrapper),
      dirResults: $('.js-directions-results', $wrapper),
      dirPanel: $('.js-directions-panel', $wrapper),
      dirMap: $('.js-directions-map-container', $wrapper),
      dirDestination: $('.js-destination', $wrapper),
      dirFromAddr: $('.js-from-address', $wrapper),
      dirSTSS: $('input[name="filter_store_types"][value="filter_store_type_salon_spa"]', $wrapper),
      dirSTSa: $('input[name="filter_store_types"][value="filter_store_type_salons"]', $wrapper),
      dirSTS: $('input[name="filter_store_types"][value="filter_store_type_stores"]', $wrapper),
      dirECs: $('input[name="filter_store_types"][value="filter_store_type_ecs"]', $wrapper),
      dirSTFS: $(
        'input[name="filter_store_types"][value="filter_store_type_family_salons"]',
        $wrapper
      ),
      dirPTMB: $(
        'input[name="filter_product_types"][value="filter_product_type_men_barbery"]',
        $wrapper
      ),
      dirPTHC: $(
        'input[name="filter_product_types"][value="filter_product_type_hair_color"]',
        $wrapper
      ),
      dirPTPP: $(
        'input[name="filter_product_types"][value="filter_product_type_pure_privilege"]',
        $wrapper
      ),
      dirPTSS: $(
        'input[name="filter_product_types"][value="filter_product_type_spa_services"]',
        $wrapper
      ),
      dirPTS: $(
        'input[name="filter_product_types"][value="filter_product_type_sensory"]',
        $wrapper
      ),
      dirPEM: $(
        'input[name="filter_product_types"][value="filter_product_type_earth_month"]',
        $wrapper
      ),
      dirSTHB: $(
        'input[name="filter_store_types"][value="filter_store_type_health_beauty"]',
        $wrapper
      ),
      storeFilters: $('.js-store-locator-store-filters', $wrapper),
      productFilters: $('.js-store-locator-product-filters', $wrapper),
      customFilersData: $('.js-store-locator-custom_filters_data', $wrapper),
      customFilters: $('.js-store-locator-custom_filters', $wrapper),
      customServiceButtons: $('.js-locator-results-services-button', $wrapper),
      invalidZip: $('.js-locator-invalid-zip', $wrapper),
      missingCityUS: $('.js-locator-missing-city-us', $wrapper),
      missingCityIntl: $('.js-locator-missing-city-intl', $wrapper),
      missingStartAddr: $('.js-locator-missing-start-address', $wrapper),
      dirInvalidAddress: $('.js-locator-dir-invalid-address', $wrapper),
      dirNoRoute: $('.js-locator-dir-no-route', $wrapper),
      dirUnknownError: $('.js-locator-dir-unknown-error', $wrapper),
      dirUOM: $('#locator-form-distance_unit', $wrapper).text(),
      storeQueryFields: $('.js-store-query-fields', $wrapper),
      localRegionIds: $('.js-region-ids', $wrapper),
      intllocalRegionIds: $('.js-intl-region-ids', $wrapper),
      stateContainer: $('.js-state-container', $wrapper),
      coreSiteContainer: $('.store-locator__controls', $wrapper),
      localCountryContainer: $('.js-local-country-container', $wrapper),
      mapRecenteringContainer: $('.js-map-recentering-search', $wrapper),
      mapRecenteringButton: $('.js-map-recentering-search-prompt-button', $wrapper),
      locatorInfo: $('.js-store-locator-info', $wrapper),
      locallanguage: $('#language_id', $wrapper),
      cityLocalize: $('#city_localize', $wrapper),
      errors: {
        noSearchTerm: $('.js-locator-error-messages .no-search-term', $wrapper),
        noLocationsFound: $('.js-locator-error-messages .no-locations-found', $wrapper),
        unrecognizedSearchTerm: $('.js-locator-error-messages .unrecognized-searchterm', $wrapper),
        noStoresFound: $('.js-locator-error-messages .no-stores-found', $wrapper)
      },
      toolTipTemplates: $('.location_tooltip_container', $wrapper)
    };

    if (!navigator.geolocation) {
      site.locator.nodes.searchBtnGeo.parent('.form_element').detach();
      site.locator.nodes.searchAltTxt.detach();
    }

    // Defaults
    if (_.isEmpty(site.locator.nodes.dirUOM)) {
      site.locator.nodes.dirUOM = 'mile';
    }

    if (site.locator.nodes.storeQueryFields.length > 0) {
      site.locator.queryFields = site.locator.nodes.storeQueryFields.val();
    }
  };

  // Methods used when searching by state - due to big radius, result may contain salons from other states or countries
  site.locator.filterBy = function (result, value, field) {
    var i;

    if (result instanceof Array) {
      for (i = result.length - 1; i >= 0; --i) {
        if (result[i][field] !== value) {
          result.splice(i, 1);
        }
      }
    } else {
      for (i in result) {
        if (result[i][field] !== value) {
          delete result[i];
        }
      }
    }

    return result;
  };

  _.extend(site.locator.ui, {
    reset: function () {
      $('input.js-search', site.locator.nodes.container).removeClass('error');
      $.each(site.locator.nodes.errors, function () {
        $(this).addClass('inactive');
      });
      site.locator.nodes.dirAddrInput.val('');
    },

    /**
     * This function initializes the UI elements of the Store Locator page.
     * It communicates with site.locator.data via events.
     */
    init: function () {
      let mainWindow = window;
      let isIframe = false;
      let canAccessTop = false;

      if (window.top !== window) {
        isIframe = true;

        try {
          /* Try to access location properties; this won't work if we're
           * cross-origin
           */
          void window.top.location.href;

          // If we get here, we're same-origin - it's safe to use top
          mainWindow = window.top;
          canAccessTop = true;
        } catch {
          // Cross-origin; can't access `top` properties
        }
      }

      var undef;

      // set the default countries to the values passed by drupal
      site.locator.defaultCountries = site.locator.nodes.container.data('local-countries');

      /*
       * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
       */
      var _clearMenu = function (menu) {
        // menu[0].options.length = 0;
        // wipe out menu html
        menu.html('');

        // rebuild
        generic.forms.select.addOption({
          menuNode: menu,
          label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.selectText.text(),
          value: ''
        });
      };
      /*
       * Initializes select menus by adding default option and populating the State menu from JSON data in page
       */
      var _initMenus = function () {
        $([
          site.locator.nodes.countryMenu,
          site.locator.nodes.localcountryMenu,
          site.locator.nodes.cityMenuIntl,
          site.locator.nodes.stateMenu,
          site.locator.nodes.cityMenu,
          site.locator.nodes.doorMenu
        ]).each(function () {
          _clearMenu($(this));
        });

        // core site store
        var country;
        var state;
        var city;

        // Populate the country dropdown for the directions menu
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.dirCountryMenu,
          value: site.locator.defaultCountries
        });

        var country;
        var state;
        var city;

        // populate local country select first if visible
        for (country in site.locator.locationData) {
          if (_.isEmpty(country)) {
            continue;
          }
          if (site.locator.defaultCountries.indexOf(country) !== -1) {
            if (
              site.locator.nodes.stateContainer.hasClass('neither') ||
              site.locator.nodes.cityMenu.length > 0
            ) {
              // only showing city filter...
              for (state in site.locator.locationData[country]) {
                // if ( state == "" ) { continue; }
                for (city in site.locator.locationData[country][state]) {
                  generic.forms.select.addOption({
                    menuNode: site.locator.nodes.cityMenu,
                    value: city
                  });
                }
              }
            } else if (!site.locator.nodes.localCountryContainer.hasClass('state')) {
              // showing local country filter...
              generic.forms.select.addOption({
                menuNode: site.locator.nodes.localcountryMenu,
                value: country
              });
            } else {
              // showing state
              for (state in site.locator.locationData[country]) {
                if (state === '') {
                  continue;
                }
                generic.forms.select.addOption({
                  menuNode: site.locator.nodes.stateMenu,
                  value: state
                });
              }
            }
          } else {
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.countryMenu,
              value: country
            });
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.dirCountryMenu,
              value: country
            });
          }
        }
        site.locator.nodes.countryMenu.val(site.locator.ui.getCountryVal());
        var search = site.locator.ui.getSearchVal();

        country = _updateCountry(country);

        site.locator.geocoder.find({
          params: {
            address: search,
            componentRestrictions: { country: country }
          },
          intlSearch: site.locator.isIntlSearch,
          resultFilter: {
            blacklist: true,
            partialBlacklist: true
          },
          successHandler: function (filteredResults, results) {},
          errorHandler: function (results, status) {}
        });

        // Manually trigger the change handler so that the internation city drop-down gets populated
        _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
      };
      var _localcountryMenuChangeHandler = function (stateNode, cityNode) {
        _clearMenu(stateNode);
        _clearMenu(cityNode);

        // populate state drop-down if visible, otherwise populate city drop-down
        var state;

        if (!site.locator.nodes.stateContainer.hasClass('country')) {
          for (state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
            if (state === '') {
              continue;
            }
            generic.forms.select.addOption({
              menuNode: stateNode,
              value: state
            });
          }
          stateNode.focus();
        } else {
          var cities = {};

          for (state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
            $.extend(
              cities,
              site.locator.locationData[site.locator.nodes.localcountryMenu.val()][state]
            );
          }
          _filterCityMenu(cityNode, cities);
          _sortSelect(cityNode);
          cityNode.focus();
        }

        _refreshSelect(stateNode);
        _refreshSelect(cityNode);
      };
      var _countryMenuChangeHandler = function (cityNode) {
        var cities = {};
        var state;

        for (state in site.locator.locationData[site.locator.nodes.countryMenu.val()]) {
          $.extend(cities, site.locator.locationData[site.locator.nodes.countryMenu.val()][state]);
        }

        _refreshSelect(site.locator.nodes.countryMenu);
        _filterCityMenu(cityNode, cities);

        cityNode.focus();
      };
      /*
       * Event handler for onchange event on State menu
       */
      var _stateMenuChangeHandler = function (cityNode, locationData) {
        _filterCityMenu(cityNode, locationData[site.locator.nodes.stateMenu.val()]);
        cityNode.focus();
      };
      /*
       * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
       */
      var _filterCityMenu = function (cityNode, locationData) {
        _clearMenu(cityNode);
        // retrieve cities from that state, populate city menu
        var cityData = locationData;
        var city;

        for (city in cityData) {
          generic.forms.select.addOption({
            menuNode: cityNode,
            value: city
          });
        }

        _clearMenu(site.locator.nodes.doorMenu);
        _refreshSelect(cityNode);
      };
      /*
       * Modify country name for Hong Kong, Antigua and Puerto Rico as per Google API.
       */
      var _updateCountry = function (country) {
        var countryName = country;

        if (countryName === 'Hong Kong, SAR of China') {
          countryName = 'Hongkong';
        } else if (countryName === 'Antigua/Barbuda') {
          countryName = 'Antigua and Barbuda';
        }

        if (window.location.hash) {
          var hasValue = window.location.hash.substring(1);
          if (hasValue === 'PR') {
            countryName = 'Puerto Rico';
          }
        }

        return countryName;
      };
      /*
       * Sort select options in alphabetical order
       */
      var _sortSelect = function (selectNode) {
        var listitems = selectNode.children('option').get();

        listitems.sort(function (a, b) {
          return $(a).text().toUpperCase() === 'SELECT'
            ? -1
            : $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
        });
        $.each(listitems, function (idx, itm) {
          selectNode.append(itm);
        });
      };
      /*
       * Event handler for onchange event on City menu
       */
      var _cityMenuChangeHandler = function (doorNode, locationData) {
        var state = site.locator.nodes.stateMenu.val();
        var city = site.locator.nodes.cityMenu.val();

        // _filterDoorMenu( doorNode, locationData[state][city] );
        doorNode.focus();
      };
      /*
       * Reads value from city menu and populates door (store) menu with the appropriate values, based on JSON data in page
       */
      var _filterDoorMenu = function (doorNode, locationData) {
        _clearMenu(doorNode);
        var storeArray = locationData;
        var i;
        var len;

        for (i = 0, len = storeArray.length; i < len; i++) {
          generic.forms.select.addOption({
            menuNode: doorNode,
            value: storeArray[i]
          });
        }
      };
      var _loadCustomAndAdditionalFilters = function () {
        var i;

        if (site.locator.nodes.customFilersData.length > 0) {
          var customFilters = site.locator.nodes.customFilersData.text().split(',');
          var cfilterHTML = '';

          for (i = 0; i < customFilters.length; i++) {
            var cfilter = customFilters[i].split('|');

            if (cfilter[2]) {
              var cfilterIconURL =
                '/media/images/locator/icon_' + cfilter[2].toLowerCase() + '.png';

              cfilterHTML +=
                '<div class="store-locator__custom_filters-item"><input type="checkbox" name="filter_types" value="' +
                cfilter[0] +
                '" /><span class="store-locator__custom_filters-item-image" style="background-image:url(' +
                cfilterIconURL +
                ');"></span>' +
                cfilter[1] +
                '</div>';
            } else {
              cfilterHTML +=
                '<div class="store-locator__custom_filters-item"><input type="checkbox" name="filter_types" value="' +
                cfilter[0] +
                '" /><span class="store-locator__custom_filters-item-image"></span>' +
                cfilter[1] +
                '</div>';
            }
          }
          site.locator.nodes.customFilters.html(cfilterHTML);
        }

        if (!!site.locator.nodes.productFilters.data('addtitional-product-filter')) {
          var addtionalProductFilters = site.locator.nodes.productFilters
            .data('addtitional-product-filter')
            .split(',');
          var pfilterHTML = '';

          for (i = 0; i < addtionalProductFilters.length; i++) {
            var pfilter = addtionalProductFilters[i].split('|');

            if (pfilter[2]) {
              var pfilterIconURL =
                '/media/images/locator/icon_' + pfilter[2].toLowerCase() + '.png';

              pfilterHTML +=
                '<div class="store-locator__checkbox-container store-locator__product_filters-item"><input type="checkbox" name="filter_product_types" class="store-locator__store_filter js-additional-product-filters" value="' +
                pfilter[0] +
                '" /><span class="store-locator__checkbox-icon"></span><span class="store-locator__product_filters-item-image" style="background-image:url(' +
                pfilterIconURL +
                ');"></span>' +
                pfilter[1] +
                '</div>';
            } else {
              pfilterHTML +=
                '<div class="store-locator__checkbox-container store-locator__product_filters-item"><input type="checkbox" name="filter_product_types" class="store-locator__store_filter js-additional-product-filters" value="' +
                pfilter[0] +
                '" /><span class="store-locator__checkbox-icon"></span><span class="store-locator__product_filters-item-image"></span>' +
                pfilter[1] +
                '</div>';
            }
          }
          site.locator.nodes.productFilters.append(pfilterHTML);
        }
      };
      /*
       * Event handler for click of Doors search button
       */
      var _searchClickHandler = function (intl) {
        intl = typeof intl !== 'undefined' ? intl : false;

        site.locator.ui.reset();
        site.locator.isIntlSearch = intl;

        var localCountriesArr = $.isEmptyObject(site.locator.defaultCountries)
          ? site.locator.defaultCountries
          : site.locator.defaultCountries.replace(/\[\]/g, '').split(',');
        // var city = site.locator.nodes.cityMenuIntl.val() || '';
        var country_all = null;
        var search = '';
        var country = '';

        // ANR-1337: with the introduction of the following conditional, there's now a bug
        // whereas saved search + internation searches don't play nicely together. Before, it was
        // just assuming "search" was blank, so there was no issue.
        if (!!intl) {
          search = site.locator.nodes.cityMenuIntl.val();
          country = site.locator.nodes.countryMenu.val();
        } else {
          search = site.locator.ui.getSearchVal();
          country = site.locator.ui.getCountryVal();
        }
        var distance = site.locator.nodes.distanceMenu.val();
        var bps = Unison.fetch.all();
        var bp = Unison.fetch.now();
        var isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
        // Setting the default country to US for one isn't selected.
        var isUS =
          country.match(/^united states*/i) || $.inArray(country, localCountriesArr)
            ? true
            : !!(!country || !country.length);

        // Restrict address requirement to US searches only.
        // If the user has attempted a "manual" search with no location/term, throw an error.
        if (isUS) {
          if (!search) {
            site.locator.nodes.errors.noSearchTerm.removeClass('inactive');
            site.locator.nodes.errors.noLocationsFound.addClass('inactive');
            $('input.js-search', site.locator.nodes.container).addClass('error');
            generic.focusErrors(
              site.locator.nodes.locatorErrors,
              site.locator.nodes.storeLocatorHero
            );

            return;
          } else {
            site.locator.nodes.errors.noSearchTerm.addClass('inactive');
          }

          // Setting these manually.
          if (!distance || isNaN(distance)) {
            distance = site.locator.defaultDistance; // Must ensure a minimum radius.
          }
        }

        country = _updateCountry(country);

        var defaultLocatorCountry = site.locator.nodes.container.data('defaultLocatorCountry');

        if (typeof defaultLocatorCountry !== 'undefined') {
          if (search.match(/^\d{7}$/u) && defaultLocatorCountry.includes(country)) {
            search = search.replace(/(\d{3})(\d{4})/u, '$1-$2');
          }
        }
        // get current content from main search text field, and run it through the geocoder
        site.locator.geocoder.find({
          params: {
            address: search,
            componentRestrictions: country ? { country: country } : undefined
          },
          intlSearch: site.locator.isIntlSearch,
          resultFilter: {
            blacklist: true,
            partialBlacklist: true
          },
          successHandler: function (filteredResults, results) {
            var i;

            if (!site.locator.nodes.container.hasClass('js-search-by-state__enabled')) {
              site.locator.isState = false;
            } else {
              for (i = 0; i < results[0].address_components.length; i++) {
                if (results[0].address_components[i].types.indexOf('locality') !== -1) {
                  site.locator.isState = false;
                  break;
                }
                if (results[0].address_components[i].types[0] === 'administrative_area_level_1') {
                  site.locator.isState = true;
                }
              }
            }
            site.locator.state = results[0].address_components[0].short_name;
            if (site.locator.isState) {
              distance = site.locator.defaultStateDistance;
            }

            // ANR-1337: disabling saved searches here due to the bug noted above.
            // sessionStorage.setItem('search', search);
            // Handle country searches.
            if (!isUS) {
              if (!search) {
                filteredResults = results;
                country_all = country;
              }
            }

            if (site.locator.nodes.coreSiteContainer.hasClass('js-core-site-store')) {
              filteredResults = results;
            }

            if (filteredResults && filteredResults.length > 0) {
              site.locator.ui.searchBaseHandler(
                results[0].geometry.location.lat(),
                results[0].geometry.location.lng(),
                distance,
                country_all,
                intl
              );

              $(document).bind('locator.searchQuerySuccess', function (evt, param) {
                site.locator.addressDisplayData = results[0].formatted_address;
                site.locator.foundLocationData = results;
                site.locator.remainingLocationData = results.slice(1);
                site.locator.nodes.container
                  .removeClass('store-locator--error')
                  .addClass('store-locator--results');
                site.locator.toggleFooterPosition(true);
                $(document).trigger('loader.end', [site.locator.nodes.container]);
                if (isDesktop) {
                  site.locator.nodes.heroContainer.prependTo(site.locator.nodes.resultsContainer);
                } else if (
                  !!site.locator.nodes.container.data('display-store-search-form-in-mobile')
                ) {
                  site.locator.nodes.heroContainer.prependTo(site.locator.nodes.locatorInfo);
                }

                _finishOnResultsToDisplay();

                Unison.on('change', function (bp) {
                  bp = Unison.fetch.now();
                  isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
                  if (isDesktop) {
                    site.locator.nodes.heroContainer.prependTo(site.locator.nodes.resultsContainer);
                  } else if (
                    !isDesktop &&
                    !!site.locator.nodes.container.data('display-store-search-form-in-mobile')
                  ) {
                    site.locator.nodes.heroContainer.prependTo(site.locator.nodes.locatorInfo);
                  }
                });
              });
            } else {
              site.locator.nodes.errors.noLocationsFound.removeClass('inactive');
              site.locator.nodes.container.addClass('store-locator--error');
              site.locator.toggleFooterPosition(false);
              $('input.js-search', site.locator.nodes.container).addClass('error');
              generic.focusErrors(
                site.locator.nodes.locatorErrors,
                site.locator.nodes.storeLocatorHero
              );
            }
          },
          errorHandler: function (results, status) {
            site.locator.toggleFooterPosition(false);
            $('input.js-search', site.locator.nodes.container).addClass('error');
            generic.focusErrors(
              site.locator.nodes.locatorErrors,
              site.locator.nodes.storeLocatorHero
            );
            site.locator.nodes.errors.unrecognizedSearchTerm.removeClass('inactive');
          }
        });
      };
      var _searchGeoClickHandler = function (doGeoSearch) {
        doGeoSearch = typeof doGeoSearch !== 'undefined' ? doGeoSearch : true;

        var bps = Unison.fetch.all();
        var bp = Unison.fetch.now();
        var isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);

        site.locator.ui.reset();

        var _doGeoSearch = function (args) {
          var door = site.locator.nodes.doorMenu.val();
          var distance;

          if (site.locator.isState) {
            distance = site.locator.defaultStateDistance;
          } else {
            distance = site.locator.nodes.distanceMenu.val();
          }

          // Setting these manually.
          if (!distance || isNaN(distance)) {
            distance = site.locator.defaultDistance; // Must ensure a minimum radius.
          }

          var storeList = [];

          if (!!door) {
            if (door.length > 0) {
              storeList[0] = door;
              site.locator.queryArgs.params[0].show_stores_list = storeList;
            }
          }

          // find the containing zip code, then send the query
          site.locator.geocoder.find({
            params: { latLng: new google.maps.LatLng(args.lat, args.lng) },
            resultFilter: { whitelist: true },
            successHandler: function (filteredResults, results) {
              sessionStorage.setItem('search', 'geo');
              site.locator.ui.searchBaseHandler(args.lat, args.lng, distance);

              $(document).bind('locator.searchQuerySuccess', function (evt, param) {
                site.locator.queryArgs.addressDisplayData = filteredResults.length
                  ? filteredResults[0].address_components[0].long_name
                  : '';
                $(document).trigger('loader.end', [site.locator.nodes.container]);
                site.locator.nodes.container.addClass('store-locator--results');
                site.locator.toggleFooterPosition(true);

                _finishOnResultsToDisplay();

                if (isDesktop) {
                  site.locator.nodes.heroContainer.prependTo(site.locator.nodes.resultsContainer);
                }
                Unison.on('change', function (bp) {
                  bp = Unison.fetch.now();
                  isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
                  if (isDesktop) {
                    site.locator.nodes.heroContainer.prependTo(site.locator.nodes.resultsContainer);
                  } else {
                    site.locator.nodes.heroContainer.appendTo('.store-locator__hero');
                  }
                });
              });
            }
          });
        };
        // Fake geo search to help when a filter is set
        var _fakeGeoSearch = function (args) {
          site.locator.nodes.container.addClass('store-locator--results');
          site.locator.toggleFooterPosition(true);
          $(document).trigger('loader.end', [site.locator.nodes.container]);

          site.locator.nodes.heroContainer.prependTo(site.locator.nodes.resultsContainer);
          site.locator.ui.displayMap();
        };

        if (doGeoSearch) {
          site.geo.locate(_doGeoSearch, _fakeGeoSearch);
        } else {
          _fakeGeoSearch();
        }
      };
      // function for "finish" code, for geo and text searches, when there ARE results to display
      var _finishOnResultsToDisplay = function () {
        // If mobile site let's scroll page up so entire map is viewable
        if ($('body').hasClass('device-mobile')) {
          $('html, body').animate(
            {
              scrollTop: 0
            },
            300
          );
        }
      };
      var _refreshSelect = function ($selects) {
        return;

        $selects.trigger('select.enabled');
        /*
        $selects.each(function() {
          var $select = $(this);
          $select.selectbox('detach');
          $select.selectBox();
          $select.css('display', 'none');
        });
        */
      };
      var _initPlaceAutocomplete = function () {
        site.locator.ui.autocomplete = new google.maps.places.Autocomplete(
          site.locator.nodes.searchInput.get(0)
        );

        // Only bind to map bounds if the map is already initialized
        if (site.locator.map) {
          site.locator.ui.autocomplete.bindTo('bounds', site.locator.map);
        }

        site.locator.ui.autocomplete.addListener('place_changed', function () {
          var place = this.getPlace(); // btw, this === site.locator.ui.autocomplete, our autocomplete instance

          if (!place.geometry) {
            // make some error message
            return;
          }

          site.locator.ui.searchBaseHandler(
            place.geometry.location.lat(),
            place.geometry.location.lng()
          );
          site.locator.queryArgs.addressDisplayData = place.formatted_address;
        });
      };

      _initMenus();
      _loadCustomAndAdditionalFilters();

      site.locator.nodes.countryMenu.bind('change', function () {
        _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
      });

      site.locator.nodes.searchBtn.bind('click', function () {
        _searchClickHandler();
      });

      site.locator.nodes.searchBtnGeo.bind('click', function (e) {
        e.preventDefault();
        _searchGeoClickHandler();
      });

      site.locator.nodes.searchBtnIntl.bind('click', function () {
        _searchClickHandler(true);
      });

      site.locator.nodes.searchInput.bind('keydown', function (e) {
        if (e.keyCode === 13) {
          _searchClickHandler();
        }
        site.locator.nodes.searchInput.trigger('locator.search.typing', [e.keyCode]);
      });

      // csite.locator.ui.displayMap();

      if (site.locator.nodes.container.hasClass('place-autocomplete')) {
        _initPlaceAutocomplete();
      }

      // prepopulate search field with form-submitted search value, if we're passed one, then submit
      var presubmittedSearch = {
        all: generic.env.parsedQuery(),
        search: generic.env.parsedQuery().LOCATION,
        lat: generic.env.parsedQuery().LAT,
        lng: generic.env.parsedQuery().LNG
      };

      if (typeof presubmittedSearch.search == 'string') {
        site.locator.nodes.searchInput.val(
          decodeURIComponent(presubmittedSearch.search).replace('+', ' ')
        );
        site.locator.nodes.searchBtn.click();
      } else if (
        typeof presubmittedSearch.lat == 'string' &&
        typeof presubmittedSearch.lng == 'string'
      ) {
        site.locator.nodes.searchBtnGeo.trigger('click', presubmittedSearch);
      }

      /**
       * Prefill the appropriate checkboxes
       */
      const _filterOptions = [
        'salons_spas',
        'stores_only',
        'salons_only',
        'ecs_only',
        'health_beauty',
        'HC',
        'PP',
        'SS',
        'SR',
        'PP_CAN',
        'FS',
        'MB',
        'DS',
        'country',
        'city',
        'browse_eid',
        '_bta_tid',
        'dclid'
      ];
      const _utmOptions = ['utm_campaign', 'utm_medium', 'utm_term', 'utm_source'];
      const _filterUrlOptions = _filterOptions.concat(_utmOptions);
      var _filters = [];
      var _filterNodes = {
        salon_spa: $("input[name='filter_store_types'][value='filter_store_type_salon_spa']"),
        salons: $("input[name='filter_store_types'][value='filter_store_type_salons']"),
        stores: $("input[name='filter_store_types'][value='filter_store_type_stores']"),
        ecs: $("input[name='filter_store_types'][value='filter_store_type_ecs']"),
        family_salons: $(
          "input[name='filter_store_types'][value='filter_store_type_family_salons']"
        ),
        men_barbery: $(
          "input[name='filter_product_types'][value='filter_product_type_men_barbery']"
        ),
        health_beauty: $(
          "input[name='filter_store_types'][value='filter_store_type_health_beauty']"
        ),
        hair: $("input[name='filter_product_types'][value='filter_product_type_hair_color']"),
        pp: $("input[name='filter_product_types'][value='filter_product_type_pure_privilege']"),
        spa: $("input[name='filter_product_types'][value='filter_product_type_spa_services']"),
        sensory: $("input[name='filter_product_types'][value='filter_product_type_sensory']")
      };

      if (
        site.locator.nodes.customFilersData.length > 0 ||
        !!site.locator.nodes.productFilters.data('addtitional-product-filter')
      ) {
        var $customAdditionalFilters = $(
          "input[name='filter_types'], input[name='filter_product_types'].js-additional-product-filters"
        );

        $.each($customAdditionalFilters, function () {
          var filterVal = $(this).val().replace('filter_', '');

          _filterOptions.push(filterVal);
          _filterNodes[filterVal] = $(this);
        });
      }

      _.each(_filterOptions, function (val) {
        if (!_.isEmpty(presubmittedSearch.all[val])) {
          _filters.push(val);
        }
      });

      // If iframed, add filters from parent query string.
      if (isIframe && canAccessTop) {
        const searchParams = new URLSearchParams(mainWindow.location.search);
        for (const key of searchParams.keys()) {
          if (!_filterOptions[key]) {
            _filters.push(key);
          }
        }
      }

      var prefillStuffs = function (_filters, nodes) {
        var exists = function (key) {
          return _filters.indexOf(key) !== -1;
        };
        var check = function (element) {
          element.attr('checked', '1');
        };
        var uncheck = function (element) {
          element.removeAttr('checked');
        };

        nodes.family_salons.parent().hide();
        nodes.salons.parent().hide();
        nodes.ecs.parent().hide();
        if (exists('salons_spas')) {
          uncheck(nodes.stores);
          uncheck(nodes.salons);
          uncheck(nodes.family_salons);
          if (settings.override_store_filter_selection) {
            check(nodes.salon_spa);
            uncheck(nodes.stores);
            uncheck(nodes.health_beauty);
          }
        } else if (exists('stores_only')) {
          uncheck(nodes.salon_spa);
          uncheck(nodes.salons);
          uncheck(nodes.family_salons);
          if (settings.override_store_filter_selection) {
            uncheck(nodes.salon_spa);
            check(nodes.stores);
            uncheck(nodes.health_beauty);
          }
        } else if (exists('ecs_only')) {
          check(nodes.ecs);
          nodes.ecs.parent().show();
          uncheck(nodes.salon_spa);
          uncheck(nodes.stores);
          uncheck(nodes.family_salons);
        } else if (exists('salons_only')) {
          check(nodes.salons);
          nodes.salons.parent().show();
          uncheck(nodes.salon_spa);
          uncheck(nodes.stores);
          uncheck(nodes.family_salons);
        } else if (exists('FS')) {
          check(nodes.family_salons);
          nodes.family_salons.parent().show();
          uncheck(nodes.salons);
        } else if (exists('health_beauty')) {
          uncheck(nodes.salon_spa);
          uncheck(nodes.stores);
          check(nodes.health_beauty);
        }

        // Product Type filters
        if (exists('HC')) {
          check(nodes.hair);
        }
        if (exists('PP')) {
          check(nodes.pp);
        }
        if (exists('SS')) {
          check(nodes.spa);
        }
        if (exists('SR')) {
          check(nodes.sensory);
        }
        if (exists('MB')) {
          check(nodes.men_barbery);
        }

        if (
          site.locator.nodes.customFilersData.length > 0 ||
          !!site.locator.nodes.productFilters.data('addtitional-product-filter')
        ) {
          var $customAdditionalFilters = $(
            "input[name='filter_types'], input[name='filter_product_types'].js-additional-product-filters"
          );

          $.each($customAdditionalFilters, function () {
            var filterVal = $(this).val().replace('filter_', '');

            if (exists(filterVal)) {
              check(nodes[filterVal]);
            }
          });
        }

        // console.log('@TODO: finish combo filters');

        // Combo filters
        if (exists('PP_CAN')) {
          check(nodes.stores);
          check(nodes.salon_spa);
          check(nodes.pp);
        }

        // To hide results count when results page directly loaded
        if (site.locator.resultData.results.length === 0) {
          site.locator.nodes.locatorInfo.addClass('hidden');
        }

        // Trigger an event for content blocks to bind to and hide/show themselves
        $(document).trigger('locator.filters.init', [_filters]);
      };

      prefillStuffs(_filters, _filterNodes);
      /* end prefiller */

      // if (typeof presubmittedSearch.search == 'string') {

      // if we'd previously found a search term coming to us through the query string, and
      // have put it in our search field... trigger the click event, so that it's submitted
      // if (presubmittedSearch) {
      //   site.locator.nodes.searchBtn.click();
      // }

      // show status content, hide results/map
      // site.locator.nodes.staticDefaultContentArea.slideDown('slow');
      // site.locator.nodes.bodyContainer.addClass('hidden');
      // c$('.responsive-tabs--store-locator').easyResponsiveTabs();

      initDirectionsForm();
      initTravelMode();
      site.locator.nodes.toggleMapBtn.bind('click', function (e) {
        e.preventDefault();
        site.locator.nodes.bodyContainer.toggleClass('is-map-hidden');
      });

      // If mobile site let's scroll page up so entire map is viewable
      if ($('body').hasClass('device-mobile')) {
        $('html, body').animate(
          {
            scrollTop: 0
          },
          300
        );
      }

      // If there are any filters, click "search"
      if (!_.isEmpty(_filters)) {
        // site.locator.nodes.searchBtn.click();
        // site.locator.nodes.searchBtnGeo.click();
        _searchGeoClickHandler(false);
        site.locator.nodes.container.addClass('store-locator--open-filter');
      }

      if (!_.isEmpty(mainWindow.location.search) || sessionStorage.getItem('search')) {
        var search = mainWindow.location.search || sessionStorage.getItem('search');
        var isFilter = null;

        _.each(_filterUrlOptions, function (value) {
          isFilter = search.match('[?&]' + value + '=([^&]*)');
          if (!!isFilter) {
            return false;
          }
        });
        if (!isFilter) {
          search = search.replace('?', '');
          if (search === 'geo') {
            _searchGeoClickHandler();
          } else {
            if (Drupal.settings.store_locator_cm_mmc) {
              if (search.indexOf('cm_mmc') < 0) {
                site.locator.nodes.searchInput.val(search);
                _searchClickHandler();
              }
            } else {
              site.locator.nodes.searchInput.val(search);
              _searchClickHandler();
            }
          }
        }
      }
    },

    /*
     * This function fetches the JS template: /templates/locator/location_info.tmpl
     * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
     */
    buildLocationHtml: function (args) {
      site.template.get({
        name: 'location_info',
        data: args.locationData,
        callback: function (html) {
          args.callback(html);
        }
      });
    },

    /*
     * This function builds the row markup for door results
     */
    buildRow: function (doorData, idx, tbody) {
      doorData.index_number = idx;
      doorData.display_number = idx + 1;
      doorData.distanceFormatted = parseFloat(doorData.DISTANCE).toFixed(2);
      doorData.distanceFormatted = isNaN(doorData.distanceFormatted)
        ? 'Unknown'
        : doorData.distanceFormatted;
      var hasEvent;

      if (doorData.EVENT_START_DATE && doorData.EVENT_END_DATE) {
        var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
        var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));

        // PBruno: the check for the year has to  do with JS 1.2 backwards compatibility,
        // which would in some instances spit out a four-digit full year, for all
        // years not in 1900-1999; I just check for any four digit value for year,
        // and if I find one, leave it alone (forego adding the 1900)
        doorData.EVENT_DATE =
          event_start.getMonth() +
          1 +
          '/' +
          event_start.getDate() +
          '/' +
          (event_start.getYear() < 1000
            ? parseInt(event_start.getYear()) + 1900
            : event_start.getYear());
        doorData.EVENT_DATE += ' - ';
        doorData.EVENT_DATE +=
          event_end.getMonth() +
          1 +
          '/' +
          event_end.getDate() +
          '/' +
          (event_end.getYear() < 1000 ? parseInt(event_end.getYear()) + 1900 : event_end.getYear());

        hasEvent = true;
        if (doorData.EVENT_IMAGE) {
          var image_path_parts = doorData.EVENT_IMAGE.split('.');

          image_path_parts[0] += '_lrg';
          doorData.EVENT_LARGE_IMAGE = image_path_parts.join('.');
        }
      }

      // Create the little product/store type buttons in the results
      var b = [];

      if (!!site.locator.nodes.container.data('display-custom-services-only') !== true) {
        if (
          !!doorData.HAS_EXCLUSIVE_HAIR_COLOR &&
          parseInt(doorData.HAS_EXCLUSIVE_HAIR_COLOR) === 1
        ) {
          b.push({ key: 'hc' });
        }
        if (!!doorData.HAS_PURE_PRIVILEGE && parseInt(doorData.HAS_PURE_PRIVILEGE) === 1) {
          b.push({ key: 'pp' });
        }
        if (!!doorData.HAS_SPA_SERVICES && parseInt(doorData.HAS_SPA_SERVICES) === 1) {
          b.push({ key: 'ss' });
        }
        if (!!doorData.IS_GREEN_SALON && parseInt(doorData.IS_GREEN_SALON) === 1) {
          b.push({ key: 'em' });
        }
        if (!!doorData.HAS_MENS_BARBERING && parseInt(doorData.HAS_MENS_BARBERING) === 1) {
          b.push({ key: 'mb' });
        }
        if (!!doorData.HAS_RITUALS && parseInt(doorData.HAS_RITUALS) === 1) {
          b.push({ key: 'sr' });
        }
      }

      if (!!site.locator.nodes.customServiceButtons.text()) {
        var customButtons = site.locator.nodes.customServiceButtons.text().split(',');

        for (var i = 0; i < customButtons.length; i++) {
          var serviceButton = customButtons[i].split('|');

          if (!!doorData[serviceButton[0]] && parseInt(doorData[serviceButton[0]]) === 1) {
            b.push({ key: serviceButton[1].toLowerCase() });
          }
        }
      }

      doorData.buttons = b;

      // Appointment booking integration
      doorData.can_book = false;
      if (doorData.APPT_BOOK_COUNTER_ID && appt_book_now) {
        doorData.APPT_URL =
          'https://' +
          window.location.hostname +
          '/book-appointment?counter_id=' +
          doorData.APPT_BOOK_COUNTER_ID;
        doorData.can_book = true;
      }

      site.template.get({
        name: 'door_row',
        data: doorData,
        callback: function (html) {
          var idx = doorData.index_number;
          var node = $(html);

          if (doorData.COUNTRY !== site.locator.defaultCountry) {
            node.find('.directions').hide();
          }
          tbody.append(node);
          var row = tbody.find('.door_row_' + idx);
          var $storeDiv = $('.store-locator__tooltip');
          var $classificationTitle = row.find('.store-locator__tooltip-classification');
          var $productTypes = row.find('.store-locator__tooltip-product-types .pc');
          var $toolTipCollection = $classificationTitle.add($productTypes);

          if (Drupal.settings.common.store_locator_localize_classification) {
            var classificationKey = $classificationTitle.html().toLowerCase().replace(' ', '_');
            var localizedClassification = $('.js-classification_' + classificationKey).html();

            if (localizedClassification) {
              $classificationTitle.html(localizedClassification);
            }
          }

          // Assume first store is shown in map
          $('.door_row_0').addClass('selected');

          site.locator.nodes.doorRows.add(row);
          if (hasEvent) {
            site.locator.nodes.doorWithEventRows.add(row);
          } else {
            row.find('.event-details > *').css('display', 'none');
            site.locator.nodes.doorWithoutEventRows.add(row);
          }
          row.on('click', function () {
            site.locator.ui.launchInfoWindow(idx);
            // $("html, body").animate({ scrollTop: 0 }, "slow");
          });

          $storeDiv.click(function () {
            $storeDiv.removeClass('selected');
            $(this).addClass('selected');
          });
          if ($(site.locator.nodes.toolTipTemplates.selector).length !== 0) {
            var $templates = $(site.locator.nodes.toolTipTemplates.selector);

            $toolTipCollection.each(function () {
              var $that = $(this);
              var $matched_dom = '';
              var title_text = $that.data('key') ? $that.data('key').toLowerCase() : '';

              $templates.find('.tooltip_container--header').each(function () {
                if (
                  $(this).text().toLowerCase() === title_text ||
                  title_text === $(this).parent().data('key')
                ) {
                  $matched_dom = $(this).parent();

                  return false;
                }
              });
              $that.tooltipster({
                animation: 'fade',
                arrow: true,
                contentAsHTML: true,
                interactive: true,
                position: 'top',
                speed: 500,
                content: $matched_dom,
                theme: 'tooltipster-store-locator',
                trigger: !site.client.isMobile
                  ? 'hover'
                  : 'click' /** for mobile we may use click */,
                updateAnimation: false
              });
            });
          }
          generic.overlay.initLinks();

          // offer directions via google page
          site.locator.ui.directionsLink(row, doorData);

          var directionsLink = $('a.directions_link').eq(idx);

          directionsLink.bind('click', function (evt) {
            evt.preventDefault();
            // offer directions via google page
            // window.open("https://www.google.com/maps/dir//" + doorData.LATITUDE + "," + doorData.LONGITUDE + "/", "_blank");

            // offer directions within store_locator
            // site.locator.ui.displayMap(true, idx);
            // site.locator.ui.launchInfoWindow(idx);

            // site.locator.getDomNodes();
            initDirectionsForm();
            // site.locator.ui.resetDirections();
            // google.maps.event.trigger(site.locator.mapDir, 'resize');

            site.template.get({
              name: 'destination_address',
              data: doorData,
              callback: function (html) {
                site.locator.nodes.dirDestination.html(html);
              }
            });

            site.locator.nodes.dirDoorInput.val(doorData.DOOR_ID);
            // site.locator.ui.initDirectionsForm(doorData);
          });

          // Make sure "Book Now" buttons open a new window
          $('.js-store-locator-book-now', row).attr('target', '_blank');
        }
      });
    },

    /*
     * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
     * The site.locator.resultData.results Array must be populated.
     */
    displayResultsTable: function () {
      var tbody = null,
        ui = this;

      site.template.get({
        name: 'doors_table',
        data: {},
        callback: function (html) {
          site.locator.nodes.storeResults.html(html);
          tbody = site.locator.nodes.storeResults.find('tbody tr td');
          // resultData.results.each( function(doorID, idx) {
          //     buildRow(locations[doorID], idx, tbody);
          // });
          var index = 0;
          var searchVal = site.locator.ui.getSearchVal();

          for (const result of site.locator.resultData.sortedResults?.filter(Boolean)) {
            if (site.locator.nodes.coreSiteContainer.hasClass('js-core-site-store')) {
              if (result.CITY === searchVal) {
                ui.buildRow(result, index, tbody);
                index++;
              }
            } else {
              ui.buildRow(result, index, tbody);
              index++;
            }
          }
          var searchQuery;
          var totalResults;

          if (site.locator.queryArgs.params !== undefined && site.locator.queryArgs.params.length) {
            if (site.locator.nodes.coreSiteContainer.hasClass('js-core-site-store')) {
              totalResults = index;
            } else {
              totalResults = site.locator.resultData.sortedResults.length;
            }
            var params = site.locator.queryArgs.params[0];
            var searchCriteria = [];
            var paramKeys = ['state', 'city'];

            if (site.locator.addressDisplayData) {
              searchCriteria.push(site.locator.addressDisplayData);
              site.locator.addressDisplayData = null;
            } else if (params.zip !== '' && params.zip !== undefined) {
              searchCriteria.push(params.zip);
            } else if (site.locator.queryArgs.addressDisplayData) {
              searchCriteria.push(site.locator.queryArgs.addressDisplayData);
            } else {
              for (var i = 0; i < paramKeys.length; i++) {
                var paramKey = paramKeys[i];

                if (params[paramKey] !== undefined) {
                  searchCriteria.push(params[paramKey]);
                }
              }
            }
            searchQuery = $.trim(searchCriteria.join(' '));

            if (
              site.locator.nodes.locatorInfo.hasClass('hidden') &&
              site.locator.resultData.results.length !== 0
            ) {
              site.locator.nodes.locatorInfo.removeClass('hidden');
            }

            var $resultCountNode =
                totalResults === 1 ? $('.results-count-singular') : $('.results-count-plural'),
              $otherCountNode =
                totalResults === 1 ? $('.results-count-plural') : $('.results-count-singular'),
              resultCountText =
                totalResults === 1
                  ? $('#locator-results-count-singular').text()
                  : $('#locator-results-count-plural').text();

            $resultCountNode
              .html(
                resultCountText
                  .replace('::count::', '<span class="count">' + totalResults + '</span>')
                  .replace('::query::', '<span class="query">' + searchQuery + '</span>')
              )
              .show();
            $otherCountNode.hide();
          }

          addthisevent.refresh();

          var omnidata = [searchQuery, totalResults];

          if (!!tms_page_data && !!tms_page_data.tms_page_info) {
            tms_page_data.tms_page_info.STORELOCATOR = omnidata;
          }
          $(window).trigger('STORELOCATOR', [omnidata]);
        }
      });

      /*
       * Initializes the Driving Directions form. Populates State menu. On form submit,
       * the starting address values are concatenated and passed to the data query method
       * via the "locator:submitDirectionsQuery" event.
       */
      var _initDirectionsForm = function () {
        site.locator.nodes.dirSubmit.bind('click', function () {
          var args = {
            startAddress: site.locator.nodes.dirAddrInput.val()
          };
          var doorId = site.locator.nodes.dirDoorInput.val();

          args.doorData = site.locator.resultData.results[doorId];
          $(document).trigger('locator.submitDirectionsQuery', [args]);
        });
      };
      var _clearMenu = function (menu) {
        $(menu).html('');
        generic.forms.select.addOption({
          menuNode: menu,
          label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.selectText.text(),
          value: ''
        });
      };
    },

    /*
     * Collects parameters from form input elements, packs them into parameters,
     * then passes them to search query via the "locator:submitSearchQuery" event.
     * @see site.locator.data.submitQuery
     */

    searchBaseHandler: function (lat, lng, distance, country, intl) {
      intl = typeof intl !== 'undefined' ? intl : false;

      var is_checked = function ($element) {
        return $element.is(':checked');
      };
      var searchcity = '';
      var searchVal;
      var city = site.locator.nodes.countryMenu.val() || site.locator.ui.getCountryVal();

      if (
        site.locator.nodes.coreSiteContainer.hasClass('js-core-site-store') &&
        site.locator.nodes.cityLocalize.val().trim()
      ) {
        searchVal = site.locator.ui.getSearchVal();
        city = searchVal || site.locator.nodes.countryMenu.val();
        var citylocaldata = site.locator.nodes.cityLocalize.val().split(',');

        searchcity = citylocaldata[citylocaldata.indexOf(city)];
      } else {
        searchcity = city;
      }

      // Base query parameters
      var queryArgs = {
        params: [
          {
            fields: site.locator.queryFields,
            radius: distance || site.locator.nodes.distanceMenu.val(),
            country: site.locator.nodes.countryMenu.val() || site.locator.ui.getCountryVal(),
            city: searchcity,
            region_id: site.locator.nodes.localRegionIds.val()
              ? site.locator.nodes.localRegionIds.val()
              : '',
            language_id: site.locator.nodes.locallanguage.val()
              ? site.locator.nodes.locallanguage.val()
              : '',
            latitude: lat,
            longitude: lng,
            uom: site.locator.nodes.dirUOM
          }
        ]
      };
      var addFilterParams = function ($element) {
        $.each($element, function () {
          if (is_checked($(this))) {
            queryArgs.params[0][$(this).val()] = 1;
          }
        });
      };

      // Remove the filters for international stores queries
      if (!intl) {
        var pf = 'filter_store';

        if (is_checked(site.locator.nodes.dirSTSS) && is_checked(site.locator.nodes.dirSTS)) {
          // Salons/Spas and Stores
          pf = 'filter_salon_spa_store';
          if (
            site.locator.nodes.container.data('enable-health-beauty-salon') &&
            site.locator.nodes.container.data('enable-health-beauty-salon') === true &&
            is_checked(site.locator.nodes.dirSTHB)
          ) {
            // Salons/Spas and Stores and Health&Beauty Stores
            pf = 'filter_salon_spa_health_beauty_store';
          }
        } else if (is_checked(site.locator.nodes.dirSTSS)) {
          // Salons/Spas
          pf = 'filter_salon_spa';
        } else if (is_checked(site.locator.nodes.dirSTS)) {
          // Stores
          pf = 'filter_store';
        } else if (is_checked(site.locator.nodes.dirSTSa)) {
          // Salons
          pf = 'filter_salons_only';
        } else if (is_checked(site.locator.nodes.dirECs)) {
          // Experience Centers
          pf = 'filter_ecs_only';
        } else if (
          site.locator.nodes.container.data('enable-health-beauty-salon') &&
          site.locator.nodes.container.data('enable-health-beauty-salon') === true &&
          is_checked(site.locator.nodes.dirSTHB)
        ) {
          pf = 'filter_health_beauty_family_salon';
        }

        if (is_checked(site.locator.nodes.dirSTSS) && is_checked(site.locator.nodes.dirSTFS)) {
          // Family salons only when Salons/Spas is checked
          pf = pf + '_family';
        }

        if (site.locator.nodes.customFilersData.length > 0) {
          addFilterParams($('input[name="filter_types"]'));
        }

        if (!!site.locator.nodes.productFilters.data('addtitional-product-filter')) {
          addFilterParams($('input[name="filter_product_types"].js-additional-product-filters'));
        }

        if (site.locator.nodes.storeFilters.length > 0) {
          queryArgs.params[0]['primary_filter'] = pf;
        }
        if (site.locator.nodes.productFilters.length > 0) {
          queryArgs.params[0]['filter_HC'] = is_checked(site.locator.nodes.dirPTHC) ? 1 : 0;
          queryArgs.params[0]['filter_PP'] = is_checked(site.locator.nodes.dirPTPP) ? 1 : 0;
          queryArgs.params[0]['filter_SS'] = is_checked(site.locator.nodes.dirPTSS) ? 1 : 0;
          queryArgs.params[0]['filter_SR'] = is_checked(site.locator.nodes.dirPTS) ? 1 : 0;
          queryArgs.params[0]['filter_EM'] = is_checked(site.locator.nodes.dirPEM) ? 1 : 0;
          queryArgs.params[0]['filter_MB'] = is_checked(site.locator.nodes.dirPTMB) ? 1 : 0;
        }
      }

      // Add intl city for intl requests
      if (!!intl) {
        // cityMenuIntl
        if (!_.isEmpty(site.locator.nodes.cityMenuIntl.val())) {
          queryArgs.params[0]['city'] = site.locator.nodes.cityMenuIntl.val();
        }
      }

      queryArgs.callback = function () {
        site.locator.ui.displayMap();
        site.locator.ui.displayResultsTable();
      };

      $(document).trigger('locator.submitSearchQuery', [queryArgs]);

      site.locator.queryArgs = queryArgs;
      site.locator.lastSearchContext = {
        lat: lat,
        lng: lng,
        distance: distance,
        country: country,
        intl: intl
      };
    },

    initMapRecenteringSearch: function () {
      site.locator.nodes.mapRecenteringContainer.hide();
      site.locator.map.addListener('dragend', function () {
        var lat = this.getCenter().lat(),
          lng = this.getCenter().lng();

        site.locator.nodes.mapRecenteringButton.unbind('click').bind('click', function () {
          site.locator.ui.searchBaseHandler(lat, lng, site.locator.defaultDistance);
          // site.locator.queryArgs.addressDisplayData = place.formatted_address;
          site.locator.nodes.mapRecenteringContainer.hide();
        });
        site.locator.nodes.mapRecenteringContainer.show();
      });
    },

    // To fetch the search text value based on the CMS update by either city/free text
    getSearchVal: function () {
      var search = '';
      var cityVal = site.locator.nodes.cityMenu.length > 0 ? site.locator.nodes.cityMenu.val() : '';
      var searchTextVal =
        site.locator.nodes.searchInput.length > 0
          ? $.trim(
              site.locator.nodes.searchInput
                .val()
                .replace(site.locator.nodes.searchInput.attr('placeholder'), '')
            )
          : '';

      if (site.locator.isIntlSearch) {
        search = site.locator.nodes.cityMenuIntl.val();
      } else {
        search = searchTextVal || cityVal;
      }

      return search;
    },
    getCountryVal: function () {
      var country;
      var countryCityList = {};
      var countryFilterArr;
      var countryCityMap;
      var countryCityArr;
      var cityVal;

      if (
        site.locator.nodes.container.data('default-country').indexOf(',') !== -1 &&
        site.locator.nodes.container.data('default-country').indexOf(':') !== -1
      ) {
        countryCityArr = site.locator.nodes.container.data('default-country').split(',');
        cityVal = site.locator.nodes.cityMenu.length > 0 ? site.locator.nodes.cityMenu.val() : '';
        for (countryCityMap in countryCityArr) {
          countryFilterArr = countryCityArr[countryCityMap].split(':');
          countryFilterArr[1] && (countryCityList[countryFilterArr[0]] = countryFilterArr[1]);
        }
        country = cityVal !== '' ? countryCityList[cityVal] : countryFilterArr[1];
      } else {
        country = site.locator.nodes.container.data('default-country');
      }

      return country;
    },

    /*
     * This function encapsulates the various calls to the Google Maps API that render
     * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
     * adds markers, and sets up the event handler for clicking on the markers.
     * The site.locator.resultData.results Array must be populated.
     */
    displayMap: function (directions, i) {
      var results = i === 0 || i ? [i] : site.locator.resultData.results;
      const sortedResults = site.locator.resultData.sortedResults?.filter(Boolean);
      var mapNode = directions ? site.locator.nodes.dirMap : site.locator.nodes.map;
      var recenterNumber;
      var recenterBounds;
      var country = site.locator.nodes.countryMenu.val() || site.locator.ui.getCountryVal();
      var mapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: true,
        clickableIcons: false,
        styles: !site.locator.nodes.container.hasClass('remove-map-style')
          ? [
              {
                elementType: 'labels.text.fill',
                stylers: [{ color: '#0c2619' }]
              },
              {
                featureType: 'landscape',
                stylers: [{ color: '#ffffff' }, { visibility: 'on' }]
              },
              {
                featureType: 'poi',
                stylers: [{ color: '#98a699' }, { visibility: 'simplified' }]
              },
              {
                featureType: 'poi',
                elementType: 'geometry.fill',
                stylers: [{ color: '#dbe1dd' }]
              },
              {
                featureType: 'road.highway',
                stylers: [{ saturation: -90 }, { visibility: 'simplified' }]
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [{ color: '#98a699' }]
              },
              {
                featureType: 'road.arterial',
                stylers: [{ saturation: -90 }, { visibility: 'simplified' }]
              },
              {
                featureType: 'road.arterial',
                elementType: 'geometry.fill',
                stylers: [{ color: '#9e9e9e' }]
              },
              {
                featureType: 'road.arterial',
                elementType: 'labels.text.stroke',
                stylers: [{ color: '#0c2619' }, { weight: 1 }]
              },
              {
                featureType: 'road.local',
                stylers: [{ color: '#9e9e9e' }, { visibility: 'simplified' }]
              },
              {
                featureType: 'road.local',
                elementType: 'labels.text.stroke',
                stylers: [{ color: '#0c2619' }, { weight: 1 }]
              },
              {
                featureType: 'transit',
                stylers: [{ saturation: -90 }, { color: '#dbe1dd' }, { visibility: 'simplified' }]
              },
              {
                featureType: 'administrative.province',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'water',
                elementType: 'labels',
                stylers: [{ visibility: 'on' }, { lightness: -25 }, { saturation: -100 }]
              },
              {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#5b705f' }]
              }
            ]
          : ''
      };

      if (!results || results.length === 0) {
        mapOptions.zoom = 4;
      } else {
        mapOptions.center = new google.maps.LatLng(
          site.locator.resultData.latitude,
          site.locator.resultData.longitude
        );
        if (directions) {
          mapOptions.zoom = 15;
        } else {
          recenterNumber = site.locator.nodes.container.data('recenter-on-pins-number');
          if (recenterNumber && !isNaN(recenterNumber)) {
            recenterBounds = new google.maps.LatLngBounds();
            for (i = 0; i < recenterNumber && i < sortedResults.length; i += 1) {
              recenterBounds.extend({
                lat: Number(sortedResults[i].LATITUDE),
                lng: Number(sortedResults[i].LONGITUDE)
              });
            }
          } else {
            mapOptions.zoom = 12;
          }
        }
      }

      var map = !!site.locator.nodes.container.data('refresh-map-on-stores-filtering')
        ? new google.maps.Map(mapNode[0], mapOptions)
        : site.locator.map || new google.maps.Map(mapNode[0], mapOptions);

      if (recenterBounds) {
        map.fitBounds(recenterBounds);
      }

      // if there are no results, center the map on the US, display the map, and just return
      if (!results || results.length === 0) {
        site.locator.geocoder.find({
          params: { address: site.locator.ui.getCountryVal() },
          successHandler: function (filteredResults, results) {
            var ne = results[0].geometry.viewport.getNorthEast();
            var sw = results[0].geometry.viewport.getSouthWest();

            map.setCenter(results[0].geometry.location);
            map.fitBounds(results[0].geometry.viewport);
          },
          errorHandler: function (results, status) {}
        });
      }

      if (directions) {
        site.locator.mapDir = map;
      } else {
        site.locator.map = map;

        // Bind autocomplete to map bounds now that the map is available
        if (site.locator.ui.autocomplete) {
          site.locator.ui.autocomplete.bindTo('bounds', site.locator.map);
        }
      }

      // site.locator.nodes.landingPanel.hide();
      mapNode.show();

      if (site.locator.nodes.container.hasClass('map-recentering-search')) {
        site.locator.ui.initMapRecenteringSearch();
      }

      if (!results || results.length === 0) {
        return;
      }

      var location;
      var lat;
      var lng;
      var latLng;
      var marker;
      var searchVal;

      if (!directions) {
        var idx = 0;

        if (site.locator.nodes.coreSiteContainer.hasClass('js-core-site-store')) {
          searchVal = site.locator.ui.getSearchVal();
          for (var t in sortedResults) {
            if (sortedResults[t].CITY === searchVal) {
              location = sortedResults[t];
              lat = location.LATITUDE;
              lng = location.LONGITUDE;
              latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
              marker = site.locator.MapLocationIcon({
                id: '',
                latlng: latLng,
                // label: idx + 1, // useful when a numbered/lettered set of pins is needed
                // icon_class: (idx >= 10 ? 'hidden' : ''), // good for alternate classing, or hiding pins above a certain set of initial results, in this case
                icon_class: 'store-locator__result-pin',
                htmlContent:
                  '<img class="store-locator__result-pin-image" src="/media/images/locator/result-pin.png">',
                map: map,
                dataAttrs: [
                  {
                    key: 'store-id',
                    value: location.DOORNAME.toUpperCase()
                  },
                  {
                    key: 'door-id',
                    value: location.DOOR_ID
                  }
                ],
                clickHandler: (function (idx, location) {
                  return function () {
                    site.locator.nodes.container.addClass('detail-view');
                    $('.store-locator__result')
                      .removeClass('active')
                      .filter("[data-door-id='" + location.DOOR_ID + "']")
                      .addClass('active');

                    site.locator.ui.launchInfoWindow(idx);
                  };
                })(idx, location)
              });
              site.locator.markers[idx] = marker;
              //
              // build info window
              location.idx = idx;
              location.distanceFormatted = parseFloat(location.DISTANCE).toFixed(2);
              location.display_number = idx + 1;
              site.locator.ui.buildLocationHtml({
                locationData: location,
                callback: function (html) {
                  site.locator.locationsHtml[idx] = html;
                }
              });

              google.maps.event.addListener(marker, 'click', function () {
                site.locator.ui.launchInfoWindow(idx);
              });

              // set map center for first location
              if (idx === 0 && !recenterBounds) {
                map.setCenter(latLng);
              }
              idx++;
            }
          }
        } else {
          // When searching by state, result may contain salons from other states or countries due to big radius
          if (site.locator.isState) {
            results = site.locator.filterBy(results, country, 'COUNTRY');
            results = site.locator.filterBy(results, site.locator.state, 'STATE_OR_PROVINCE');
          }

          for (var d in results) {
            // place markers on Google Map
            location = sortedResults[idx];
            lat = location.LATITUDE;
            lng = location.LONGITUDE;
            latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
            marker = site.locator.MapLocationIcon({
              id: '',
              latlng: latLng,
              // label: idx + 1, // useful when a numbered/lettered set of pins is needed
              // icon_class: (idx >= 10 ? 'hidden' : ''), // good for alternate classing, or hiding pins above a certain set of initial results, in this case
              icon_class: 'store-locator__result-pin',
              htmlContent:
                '<img class="store-locator__result-pin-image" src="/media/images/locator/result-pin.png">',
              map: map,
              dataAttrs: [
                {
                  key: 'store-id',
                  value: location.DOORNAME.toUpperCase()
                },
                {
                  key: 'door-id',
                  value: location.DOOR_ID
                }
              ],
              clickHandler: (function (idx, location) {
                return function () {
                  site.locator.nodes.container.addClass('detail-view');
                  $('.store-locator__result')
                    .removeClass('active')
                    .filter("[data-door-id='" + location.DOOR_ID + "']")
                    .addClass('active');

                  site.locator.ui.launchInfoWindow(idx);
                };
              })(idx, location)
            });

            site.locator.markers[idx] = marker;
            //
            // build info window
            location.idx = idx;
            location.distanceFormatted = parseFloat(location.DISTANCE).toFixed(2);
            location.display_number = idx + 1;
            site.locator.ui.buildLocationHtml({
              locationData: location,
              callback: function (html) {
                site.locator.locationsHtml[idx] = html;
              }
            });

            google.maps.event.addListener(marker, 'click', function () {
              site.locator.ui.launchInfoWindow(idx);
            });

            // set map center for first location
            if (idx === 0 && !recenterBounds) {
              map.setCenter(latLng);
            }
            idx++;
          }
        }

        // display info window on first location (they're zero-indexed)
        site.locator.ui.launchInfoWindow(0);
      } else {
        location = sortedResults[i];
        lat = location.LATITUDE;
        lng = location.LONGITUDE;
        latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
        marker = new google.maps.Marker({
          icon: markerPath,
          map: map,
          position: latLng
        });
        map.setCenter(latLng);
      }
    },

    /*
     * Displays Info Window for a given marker/door.
     * @param i {Number} index of door/marker for which info window should be displayed
     */
    launchInfoWindow: function (i) {
      var location = site.locator.resultData.sortedResults[i];

      if (!location) {
        console.log('No results');
      }
      var map = site.locator.map;
      var setOffset = function (infoWindow, marker) {
        // get the height of the pin, to make sure the info window clears it
        infoWindow.setOptions({
          pixelOffset: new google.maps.Size(0, $(marker.div).height() * -1)
        });
      };
      var prevOnAddHandler;

      if (!site.locator.infoWindow) {
        site.locator.infoWindow = new google.maps.InfoWindow();
      }
      var infoWindow = site.locator.infoWindow;
      var infoWindowContent = document.createElement('div');

      infoWindowContent.innerHTML = site.locator.locationsHtml[i];
      site.locator.ui.directionsLink(infoWindowContent, location);

      infoWindow.setContent(infoWindowContent);

      var marker = site.locator.markers[i];

      if (!!marker) {
        if (marker.added) {
          setOffset(infoWindow, marker);
        } else {
          prevOnAddHandler = marker.onAddHandler;
          marker.onAddHandler = function () {
            if (prevOnAddHandler) {
              prevOnAddHandler.call(this);
            }
            setOffset(infoWindow, marker);
          };
        }

        // *
        // START INFOWINDOW CUSTOMIZE.
        // The google.maps.event.addListener() event expects
        // the creation of the infowindow HTML structure 'domready'
        // and before the opening of the infowindow, defined styles are applied.
        // *
        google.maps.event.addListener(infoWindow, 'domready', function () {
          // Reference to the DIV that wraps the bottom of infowindow
          var iwOuter = $('.gm-style-iw');
          /* Since this div is in a position prior to .gm-div style-iw.
           * We use jQuery and create a iwBackground variable,
           * and took advantage of the existing reference .gm-style-iw for the previous div with .prev().
           */
          var iwBackground = iwOuter.prev();

          // Removes background shadow DIV
          iwBackground.children(':nth-child(2)').css({ display: 'none' });

          // Add Background Color to white background DIV
          iwBackground.children(':nth-child(4)').css({ 'background-color': '#392720' });

          // Moves the arrow 76px to the left margin.
          iwBackground.children(':nth-child(3)').attr('style', function (i, s) {
            return s + 'background-color: #392720;';
          });

          // Changes the desired tail shadow color.
          iwBackground.children(':nth-child(3)').find('div').children().css({
            'background-color': '#392720',
            'box-shadow': 'none',
            'z-index': '1'
          });

          // Reference to the div that groups the close button elements.
          var iwCloseBtn = iwOuter.find('.gm-ui-hover-effect');

          // Apply the desired effect to the close button
          iwCloseBtn.css({
            height: '16px',
            width: '16px'
          });
        });

        infoWindow.open(map, marker);
        // highlight selected marker, default all others
        // for (var m = 0; m < site.locator.markers.length; m++) {
        //   var a_marker = site.locator.markers[m];
        //   var icon_index = (m > 19) ? 0 : (m+1);
        //   a_marker.setIcon((a_marker !== marker)?'/media/images/locator/icons/black_'+icon_index+'.png':'/media/images/locator/icons/pink_'+icon_index+'.png');
        //   a_marker.setZIndex(google.maps.Marker.MAX_ZINDEX - 1);
        // }
        // marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
        $('.store-locator__tooltip.selected', site.locator.nodes.storeResults).removeClass(
          'selected'
        );
        $('.store-locator__tooltip.door_row_' + i, site.locator.nodes.storeResults).addClass(
          'selected'
        );
        var $selected = $('.store-locator__tooltip.door_row_' + i, site.locator.nodes.storesContainer);
        var bps = Unison.fetch.all();
        var bp = Unison.fetch.now();
        var isDesktop = parseInt(bp.width, 10) >= parseInt(bps.landscape, 10);
        if (isDesktop) {
          if ($selected.length && site.locator.nodes.storesContainer.length) {
            site.locator.nodes.storesContainer.animate({
              scrollTop: site.locator.nodes.storesContainer.scrollTop() + ($selected.offset().top - site.locator.nodes.storesContainer.offset().top)
            }, 400);
          }
        }
        map.setCenter(marker.position);

        // Random helper function to glom the address pieces together
        var _implode = function (glue, pieces) {
          var i = '';
          var retVal = '';
          var tGlue = '';

          if (arguments.length === 1) {
            pieces = glue;
            glue = '';
          }

          if (typeof pieces === 'object') {
            if (Object.prototype.toString.call(pieces) === '[object Array]') {
              return pieces.join(glue);
            }
            for (i in pieces) {
              retVal += tGlue + pieces[i];
              tGlue = glue;
            }

            return retVal;
          }

          return pieces;
        };

        // set the "to" address every time a location is highlighted...
        if (!!location) {
          var li = _implode(' ', [
            'location.ADDRESS',
            'location.ADDRESS2',
            'location.CITY',
            'location.STATE_OR_PROVINCE',
            'location.ZIP_OR_POSTAL',
            'location.COUNTRY'
          ]);

          $('#to_address').val(li);
        }

        // clear out any directions layer and results
        site.locator.directionsDisplay =
          site.locator.directionsDisplay === null
            ? new google.maps.DirectionsRenderer()
            : site.locator.directionsDisplay;
        site.locator.directionsDisplay.setMap(null);
        site.locator.nodes.dirResults.empty();
        $('.store-locator__directions-start, .store-locator__directions-end')
          .addClass('hidden')
          .find('.address')
          .html('');
        site.locator.markerCounter++;
      } else {
        console.log('Invalid marker');
      }
    },

    directionsLink: function (row, doorData) {
      $('.js-directions-link', row).bind('click', function (e) {
        e.stopPropagation();
        var openGoogleMaps;

        if (
          site.locator.nodes.coreSiteContainer.hasClass('js-core-site-store') &&
          !site.locator.nodes.container.hasClass('js-pass-address-dir')
        ) {
          window.open(
            'https://www.google.com/maps/dir//' +
              doorData.LATITUDE +
              ',' +
              doorData.LONGITUDE +
              '/',
            '_blank'
          );
        } else {
          // Using the store name and address rather than lat/long to get a better marker when landing on the Google site - per Alicia request MAC-975
          openGoogleMaps = function (doorData) {
            var lat_long =
              ', /@' +
              (doorData.LATITUDE ? doorData.LATITUDE + ', ' : '') +
              (doorData.LONGITUDE ? doorData.LONGITUDE : '');
            var daddr =
              (doorData.DOORNAME ? doorData.DOORNAME + ', ' : '') +
              (doorData.ADDRESS ? doorData.ADDRESS + ', ' : '') +
              (doorData.ADDRESS2 ? doorData.ADDRESS2 + ', ' : '') +
              (doorData.CITY ? doorData.CITY + ', ' : '') +
              (doorData.STATE_OR_PROVINCE ? doorData.STATE_OR_PROVINCE + ', ' : '') +
              (doorData.COUNTRY ? doorData.COUNTRY + ', ' : '') +
              (doorData.ZIP_OR_POSTAL && doorData.ZIP_OR_POSTAL !== 0
                ? doorData.ZIP_OR_POSTAL
                : '') +
              (site.locator.nodes.container.data('lat-long-pass') ? lat_long : '');

            window.open('http://maps.google.com/maps?daddr=' + encodeURIComponent(daddr), '_blank');
          };
        }

        if (Drupal.settings.common.enable_current_location) {
          navigator.geolocation.getCurrentPosition(function (location) {
            if (location) {
              if (Drupal.settings.common.disable_state_province) {
                window.open(
                  'http://maps.google.com/maps?saddr=' +
                    location.coords.latitude +
                    '+' +
                    location.coords.longitude +
                    '&daddr=' +
                    encodeURIComponent(
                      doorData.DOORNAME +
                        ', ' +
                        doorData.ADDRESS +
                        ', ' +
                        doorData.ADDRESS2 +
                        ', ' +
                        doorData.CITY +
                        ', ' +
                        doorData.COUNTRY +
                        ', ' +
                        doorData.ZIP_OR_POSTAL
                    ),
                  '_blank'
                );
              } else {
                window.open(
                  'http://maps.google.com/maps?saddr=' +
                    location.coords.latitude +
                    '+' +
                    location.coords.longitude +
                    '&daddr=' +
                    encodeURIComponent(
                      doorData.DOORNAME +
                        ', ' +
                        doorData.ADDRESS +
                        ', ' +
                        doorData.ADDRESS2 +
                        ', ' +
                        doorData.CITY +
                        ', ' +
                        doorData.STATE_OR_PROVINCE +
                        ', ' +
                        doorData.COUNTRY +
                        ', ' +
                        doorData.ZIP_OR_POSTAL
                    ),
                  '_blank'
                );
              }
            } else {
              openGoogleMaps(doorData);
            }
          });
        } else {
          openGoogleMaps(doorData);
        }

        return false;
      });
    },

    /*
     * Callback function for "locator:directionsLoaded" event.
     * Hides Directions form and displays Directions results table.
     * Passes directions query response to google.maps.DirectionsRenderer object.
     * @param response {Object} response from Google Maps directions query
     */
    displayDirections: function (response) {
      // console.log(response);
      // site.locator.nodes.dirForm.addClass("hidden");
      // site.locator.nodes.dirResults.removeClass("hidden");
      // miles intead of mi
      // var miles = response.routes[0].legs[0].distance.text;
      // distance = miles.replace('mi','miles');
      // response.routes[0].legs[0].distance.text = distance;

      // response.routes[0].legs[0].start_address = $('<span><div class="store-locator__directions-destination">A</div></span>').append(response.routes[0].legs[0].start_address);
      $('.store-locator__directions-start .address')
        .html(response.routes[0].legs[0].start_address)
        .parent()
        .removeClass('hidden');
      $('.store-locator__directions-end .address')
        .html(response.routes[0].legs[0].end_address)
        .parent()
        .removeClass('hidden');
      site.locator.directionsDisplay.setDirections(response);
      // <div class="store-locator__directions-destination">A</div>
    },

    resetDirections: function () {
      site.locator.nodes.dirForm.removeClass('hidden');
      site.locator.nodes.dirResults.addClass('hidden');
    },

    /**
     * JS snippet to save the store events to calendar
     */
    saveToCalendar: function () {
      var $outlook_calendar = $('.outlook_calendar', site.locator.nodes.container);
      var $google_calendar = $('.google_calendar', site.locator.nodes.container);
      var $yahoo_calendar = $('.yahoo_calendar', site.locator.nodes.container);
      var $hotmail_calendar = $('.hotmail_calendar', site.locator.nodes.container);
      var $ical_calendar = $('.ical_calendar', site.locator.nodes.container);
      var $facebook_event = $('.facebook_event', site.locator.nodes.container);

      addthisevent.settings({
        license: 'aptrpsjrpzki5qyxvmue',
        mouse: false,
        css: false,
        outlook: {
          show: true,
          text: $outlook_calendar.html()
        },
        google: {
          show: true,
          text: $google_calendar.html()
        },
        yahoo: {
          show: true,
          text: $yahoo_calendar.html()
        },
        hotmail: {
          show: true,
          text: $hotmail_calendar.html()
        },
        ical: {
          show: true,
          text: $ical_calendar.html()
        },
        facebook: {
          show: true,
          text: $facebook_event.html()
        },
        dropdown: { order: 'outlook,google,yahoo,hotmail,ical,facebook' },
        callback: ''
      });
    },

    buildFilter: function () {
      var results = site.locator.resultData.results;
      var stores = {};
      var buildFilterBlock = function (data, callback) {
        site.template.get({
          name: 'filter_item',
          data: data,
          callback: function (html) {
            var filterItemNode = $(html);

            site.locator.nodes.filterItemsContainer.append(filterItemNode);

            filterItemNode.bind('click', function () {
              var $this = $(this);

              $this.siblings().removeClass('active');
              $this.addClass('active');

              callback.apply(this);
            });
          }
        });
      };

      if (!results) {
        return; // maybe have some error status here
      }

      // first clear the previous filter menu, if any
      site.locator.nodes.filterItemsContainer.html('');

      // then build the 'all' filter option
      buildFilterBlock(
        {
          filter_name: 'All',
          filter_id: 'ALL',
          active: true
        },
        function () {
          site.locator.nodes.resultRows.show();
          $('.map-marker').show();
        }
      );

      // finally, build out the menu options for all stores in the search results
      $.each(results, function (i, store) {
        var storeId = store.DOORNAME.toUpperCase();

        if (!stores[storeId]) {
          stores[storeId] = [];

          buildFilterBlock(
            {
              filter_name: store.DOORNAME,
              filter_id: storeId
            },
            function () {
              var $this = $(this); // this is the filter element clicked

              // make all result rows visible (if there was a previously selected row
              site.locator.nodes.resultRows.hide();
              $('.map-marker').hide();
              // now only show the results with the filter/storeId selected
              $.each(stores[storeId], function (i, doorId) {
                site.locator.nodes.resultRows.filter("[data-door-id='" + doorId + "']").show();
                $(".map-marker[data-store-id='" + storeId + "']").show();
              });
            }
          );
        }

        stores[storeId].push(i);
      });
    }
  });

  _.extend(site.locator.data, {
    /*
     * This function handles the query submit event. It parses the data from the event memo
     * and passes it to the fetch method. This method should NOT be called directly by a UI method;
     * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
     * @param {function} args.callback a function that gets called after door data is returned
     * @param {Array} args.params an Array that contains a hash of parameters that get
     * passed to the JSON-RPC method.
     * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
     * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
     * @param {string} args.params[0].zip Postal Code of origin point location
     * @param {string} args.params[0].state State of origin point location
     * @param {string} args.params[0].city City of origin point location
     * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
     * should be passed to return all stores.
     * @example
     * // var queryArgs = {
     * //     params : [{
     * //         fields : "DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY",
     * //         radius : 25,
     * //         zip    : "10014",
     * //         state  : "NY",
     * //         city   : "New York"
     * //     }],
     * //     callback : function() {
     * //          site.locator.ui.displayMap();
     * //          site.locator.ui.displayResultsTable();
     * //      }
     * // };
     */
    submitQuery: function (args) {
      var params = args.params;
      var callbackFn = args.callback;
      var zipRegEx = new RegExp(
        /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/
      );

      if (!params[0].latitude && !params[0].longitude) {
        $.each(site.locator.nodes.errors, function () {
          this.addClass('inactive');
        });
        $(document).trigger('loader.end', [site.locator.nodes.container]);
        site.locator.nodes.errors.noLocationsFound.removeClass('inactive');
        site.locator.toggleFooterPosition(false);

        return;
      }

      site.locator.data.fetch({
        data: params,
        onSuccess: function (resultData, countersData) {
          var country = site.locator.nodes.countryMenu.val() || site.locator.ui.getCountryVal();

          $.each(site.locator.nodes.errors, function () {
            this.addClass('inactive');
          });
          site.locator.nodes.container.removeClass('store-locator--error');
          // if no results were found...
          if (resultData.count === 0) {
            site.locator.nodes.errors.noStoresFound.removeClass('inactive');
            site.locator.nodes.container.addClass('store-locator--error');
            site.locator.toggleFooterPosition(false);
            generic.focusErrors(
              site.locator.nodes.locatorErrors,
              site.locator.nodes.storeLocatorHero
            );
          } else {
            site.locator.toggleFooterPosition(true);
          }
          resultData.maxDistance = parseFloat(args.params[0].radius);
          if (isNaN(resultData.maxDistance)) {
            resultData.maxDistance = null;
          }
          if (countersData) {
            for (var i = 0; i < countersData.length; i += 1) {
              var cData = countersData[i],
                res = resultData.results[cData.store_no];

              if (res) {
                res.APPT_BOOK_COUNTER_ID = cData.id;
              }
            }
          }

          // When searching by state, result may contain salons from other states or countries due to big radius
          if (site.locator.isState) {
            resultData.sorted_results = site.locator.filterBy(
              resultData.sorted_results,
              country,
              'COUNTRY'
            );
            resultData.sorted_results = site.locator.filterBy(
              resultData.sorted_results,
              site.locator.state,
              'STATE_OR_PROVINCE'
            );

            resultData.results = site.locator.filterBy(resultData.results, country, 'COUNTRY');
            resultData.results = site.locator.filterBy(
              resultData.results,
              site.locator.state,
              'STATE_OR_PROVINCE'
            );
          }

          site.locator.data.setData(resultData);
          if (typeof callbackFn === 'function') {
            callbackFn();
          }

          $(document).trigger('locator.searchQuerySuccess');
          $('.js-countdown-timer').addClass('countdown-timer--hide');
          $(window).resize();
        },
        onFailure: function (jsonRpcResponse) {
          var errorObjectsArray = jsonRpcResponse.getMessages();

          $.each(site.locator.nodes.errors, function () {
            this.addClass('inactive');
          });
          site.locator.nodes.errors.noStoresFound.removeClass('inactive');
          site.locator.nodes.container.addClass('store-locator--error');
          site.locator.toggleFooterPosition(false);

          $(document).trigger('locator.searchQueryFailure');
        }
      });

      // if first time showing results
      // site.locator.nodes.staticDefaultContentArea.slideUp('slow');
      site.locator.nodes.bodyContainer.removeClass('hidden');
    },

    /*
     * Callback function that handles response from JSON-RPC request. It filters
     * and sorts the result data, then places the data in the global variable
     * site.locator.resultData.results
     */
    fetch: function (args) {
      $(document).trigger('loader.start', [site.locator.nodes.container, {}]);

      generic.jsonrpc.fetch({
        method: 'locator.doorsandevents',
        params: args.data,
        onSuccess: function (r) {
          $(document).trigger('loader.end', [site.locator.nodes.container]);
          var resultData = r.getValue();

          if (appt_book_now) {
            generic.jsonrpc.fetch({
              method: 'appointmentbooking.getauthtoken',
              onSuccess: function (rpc) {
                var token = rpc.getValue().auth_token;

                $.ajax({
                  url: 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
                  type: 'GET',
                  data: { token: token, lite: 1 },
                  success: function (counters) {
                    args.onSuccess(resultData, counters);
                  },
                  error: function () {
                    args.onSuccess(resultData);
                  }
                });
              }
            });
          } else {
            args.onSuccess(resultData);
          }
        },
        onFailure: function (r) {
          args.onFailure(r);
        }
      });
    },
    /*
     * Callback function that handles response from JSON-RPC request. It filters
     * and sorts the result data, then places the data in the global variable
     * site.locator.resultData.results
     */
    setData: function (rawResultData) {
      const enableCustomSort = site.locator.nodes.container.hasClass('js-enable-custom-sort');
      var country = site.locator.nodes.countryMenu.val() || site.locator.ui.getCountryVal();
      var filterbyType = [];
      var filterbyClassification = [];
      var push_extra_types = 1;
      var sortedResults = [];

      site.locator.resultData = rawResultData;
      function filterByDistance(obj, maxDist) {
        var filtered = {};
        for (var key in obj) {
          if (obj[key].DISTANCE < maxDist) {
            filtered[key] = obj[key];
          }
        }
        return filtered;
      }

      if (rawResultData.maxDistance) {
        site.locator.resultData.results = filterByDistance(
          rawResultData.results,
          rawResultData.maxDistance
        );
        site.locator.resultData.sorted_results = filterByDistance(
          rawResultData.sorted_results,
          rawResultData.maxDistance
        );
      }

      if (enableCustomSort) {
        // asc. sort by distance
        var r = site.locator.resultData.results;
        var sortedDoorIds = site.locator.resultData.doors || [];
        var i;

        if (site.locator.isState) {
          for (i = sortedDoorIds.length - 1; i >= 0; --i) {
            if (!r.hasOwnProperty(sortedDoorIds[i])) {
              sortedDoorIds.splice(i, 1);
            }
          }
        }
        function sortByDistance(a, b) {
          var aDist = !r[a]?.DISTANCE || isNaN(r[a]?.DISTANCE) ? 0 : parseFloat(r[a].DISTANCE);
          var bDist = !r[b]?.DISTANCE || isNaN(r[b]?.DISTANCE) ? 0 : parseFloat(r[b].DISTANCE);

          if (aDist > bDist) {
            return 1;
          } else if (aDist < bDist) {
            return -1;
          }

          return 0;
        }

        sortedDoorIds.sort(sortByDistance);
        var len;

        for (i = 0, len = sortedDoorIds.length; i < len; i++) {
          sortedResults.push(site.locator.resultData.results[sortedDoorIds[i]]);
        }
        site.locator.resultData.sortedResults = sortedResults;

        // When searching by state, result may contain salons from other states or countries due to big radius
        if (site.locator.isState) {
          site.locator.resultData.sortedResults = site.locator.filterBy(
            sortedResults,
            country,
            'COUNTRY'
          );
          site.locator.resultData.sortedResults = site.locator.filterBy(
            sortedResults,
            site.locator.state,
            'STATE_OR_PROVINCE'
          );
        }
        // Sort the stores based on Featured & type
        if (site.locator.nodes.container.hasClass('sort-stores-featured')) {
          const filterArray = site.locator.nodes.container.data('store-type-filter').split(',');

          if (filterArray.length > 1) {
            $.each(filterArray, function (key) {
              $.each(sortedResults, function (doors_key) {
                if (sortedResults[doors_key].CLASSIFICATION === filterArray[key].trim()) {
                  filterbyType.push(sortedResults[doors_key]);
                }
                if (
                  $.inArray(sortedResults[doors_key].CLASSIFICATION, filterArray) === -1 &&
                  push_extra_types
                ) {
                  filterbyClassification.push(sortedResults[doors_key]);
                }
              });
              push_extra_types = 0;
            });
            if (sortedResults.length !== filterbyType.length) {
              filterbyType = $.merge(filterbyType, filterbyClassification);
            }
            site.locator.resultData.sortedResults = filterbyType;
          }
        } else {
          site.locator.resultData.sortedResults = sortedResults;
        }
      } else {
        // Convert sorted_results to array if it's an object, to ensure compatibility
        sortedResults = rawResultData.sorted_results;
        if (typeof sortedResults === 'object' && !Array.isArray(sortedResults)) {
          sortedResults = Object.values(sortedResults);
        }
        site.locator.resultData.sortedResults = sortedResults;
      }
    },

    /*
     * This function retrieves Driving Directions data from Google. The data
     * retrieved is then passed as a memo in the event "locator:directionsLoaded."
     */
    getDirections: function (args) {
      var directionsService = new google.maps.DirectionsService();

      site.locator.directionsDisplay =
        site.locator.directionsDisplay === null
          ? new google.maps.DirectionsRenderer()
          : site.locator.directionsDisplay;

      site.locator.nodes.dirResults.empty();
      site.locator.directionsDisplay.setMap(null);

      site.locator.directionsDisplay.setMap(site.locator.map);
      site.locator.directionsDisplay.setPanel($('.directions-form__results').get(0));
      site.locator.directionsDisplay.setOptions({
        markerOptions: {
          icon: '/media/images/locator/icons/pink_A.png'
        }
      });

      var start = $('#from_address').val();
      var end = $('#to_address').val(); // args.doorData.ADDRESS + ", " + args.doorData.CITY + " " + args.doorData.ZIP_OR_POSTAL;
      var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.DirectionsTravelMode[site.locator.travelMode]
      };

      directionsService.route(request, function (response, status) {
        $('.dirError').remove();
        if (status === google.maps.DirectionsStatus.OK) {
          $(document).trigger('locator.directionsLoaded', [response]);
        } else if (status === google.maps.DirectionsStatus.NOT_FOUND) {
          // Couldn't find address, we need to show the user an error message
          $(
            '<ul class="error_messages dirError"><li>' +
              site.locator.nodes.dirInvalidAddress.text() +
              '</li></ul>'
          ).insertAfter('.directions-header');
        } else if (status === google.maps.DirectionsStatus.ZERO_RESULTS) {
          // No route between locations
          $(
            '<ul class="error_messages dirError"><li>' +
              site.locator.nodes.dirNoRoute.text() +
              '</li></ul>'
          ).insertAfter('.directions-header');
        } else {
          // Some other error that prevented us from getting directions.
          $(
            '<ul class="error_messages dirError"><li>' +
              site.locator.nodes.dirUnknownError.text() +
              '</li></ul>'
          ).insertAfter('.directions-header');
        }
      });
    }
  });

  var initDirectionsForm = function () {
    site.locator.nodes.dirSubmit.bind('click', function (evt) {
      evt.preventDefault();
      // Check if From Address is empty, show or hide error accordingly
      if (
        site.locator.nodes.dirFromAddr.val() === 'undefined' ||
        site.locator.nodes.dirFromAddr.val() === ''
      ) {
        // Get text from missingStartAddr error node and insert it into the error element
        site.locator.nodes.dirErrors.text(site.locator.nodes.missingStartAddr.text());

        return;
      } else {
        site.locator.nodes.dirErrors.text('');
      }
      var args = {
        startAddress: site.locator.nodes.dirAddrInput.val()
      };
      var doorId = site.locator.nodes.dirDoorInput.val();

      args.doorData = site.locator.resultData.results[doorId];
      $(document).trigger('locator.submitDirectionsQuery', [args]);
    });
  };
  var initTravelMode = function () {
    $('.directions-form__transportation-mode-link[data-name]').click(function (e) {
      e.preventDefault();
      site.locator.travelMode = $(this).attr('data-name');
      site.locator.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
      $('.directions-form__transportation-mode-link[data-name]').removeClass('active');
      $(this).addClass('active');
      if ($('#to_address').val() !== '') {
        var args = {
          startAddress: site.locator.nodes.dirAddrInput.val()
        };
        var doorId = site.locator.nodes.dirDoorInput.val();

        args.doorData = site.locator.resultData.results[doorId];
        $(document).trigger('locator.submitDirectionsQuery', [args]);
      }
    });
  };

  site.locator.init = function () {
    site.locator.getDomNodes();
    site.locator.ui.getRBs();
    site.locator.ui.init();
    site.locator.ui.saveToCalendar();

    // $LAB
    //   .script('http://google-maps-utility-library-v3.googlecode.com/svn/tags/infobox/1.1.9/src/infobox_packed.js')
    //   .wait(function() {
    //     site.locator.getDomNodes();
    //     site.locator.ui.getRBs();
    //     site.locator.ui.init();
    //     site.locator.ui.saveToCalendar();
    //   });
  };

  /**
   * Event handlers
   */
  $(document).bind('locator.directionsLoaded', function (e, param) {
    site.locator.ui.displayDirections(param);
  });

  $(document).bind('locator.submitSearchQuery', function (evt, param) {
    site.locator.data.submitQuery(param);
  });

  $(document).bind('locator.submitDirectionsQuery', function (evt, param) {
    site.locator.data.getDirections(param);
  });

  /**
   * Load the google maps api script asyncronously with a callback
   */
  Drupal.behaviors.storeLocatorV1 = {
    attach: function (context, settings) {
      var $sl = $('.store-locator-v1', context).once(),
        g_lang,
        g_map_js,
        googleScript,
        regionName,
        firstScript;
      var googleApiKey = settings.google_api_key ?? settings.generic_google_api_key;

      if ($sl.length > 0) {
        g_lang = $sl.data('google-language') || '';
        g_lang = g_lang.substring(0, g_lang.indexOf('   '));
        regionName = Drupal.settings.aveda.locale.toUpperCase();
        g_map_js =
          window.location.protocol +
          '//maps.googleapis.com/maps/api/js?key=' +
          googleApiKey +
          '&libraries=geometry' +
          ($sl.hasClass('place-autocomplete') ? ',places' : '') +
          '&language=' +
          g_lang +
          '&region=' +
          regionName +
          '&v=3&callback=site.locator.init';
        googleScript = document.createElement('script');
        googleScript.async = true;
        googleScript.src = g_map_js;
        googleScript.type = 'text/javascript';
        firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(googleScript, firstScript);
        // $LAB.script(g_map_js);
      }

      // have to attach this handler here, or else it won't get attached before
      // the event it's trying to capture gets fired (previous was in
      // site.locator.init
      $(document).bind('user.loaded', function (e, data) {
        if (data.favorite_store) {
          site.locator.favoriteStoreID = data.favorite_store;
        }
      });

      // International Search Toggle
      $('.js-store-locator__international_toggle')
        .once()
        .click(function () {
          var $me = $(this),
            $caret = $me.find('.icon');

          if ($caret.hasClass('icon--caret--down')) {
            $caret.removeClass('icon--caret--down').addClass('icon--caret--up');
            $(this).attr('aria-expanded', 'true');
          } else {
            $caret.removeClass('icon--caret--up').addClass('icon--caret--down');
            $(this).attr('aria-expanded', 'false');
          }

          $me.siblings('.js-store-locator__international_controls__fields').slideToggle();
        });

      // Filtering Toggle
      $('.js-store-locator__filter_toggle')
        .once()
        .click(function () {
          var $me = $(this),
            $caret = $me.find('.icon');

          if ($caret.hasClass('icon--caret--down')) {
            $caret.removeClass('icon--caret--down').addClass('icon--caret--up');
            $(this).attr('aria-expanded', 'false');
          } else {
            $caret.removeClass('icon--caret--up').addClass('icon--caret--down');
            $(this).attr('aria-expanded', 'true');
          }

          $me.siblings('.js-store-locator__filter_controls__fields').slideToggle(400, function () {
            $(this).css({ 'overflow': 'visible' });
          });
        });

      // default_state_distance is set to 500 for US and 700 for CA in aveda/domains/local.inc
      site.locator.defaultStateDistance = settings.common.default_state_distance;

      // Remove loader once DOM ready.
      site.locator.getDomNodes();
      setTimeout(
        () => $('.js-store-locator-pre-loader', site.locator.nodes.container).remove(),
        200
      );

      // Auto-apply filters: when a filter changes, immediately refresh results
      var _handleFilterChange = function () {
        if (site.locator.lastSearchContext) {
          var ctx = site.locator.lastSearchContext;

          $(document).trigger('loader.start', [site.locator.nodes.container]);
          site.locator.ui.searchBaseHandler(ctx.lat, ctx.lng, undefined, ctx.country, ctx.intl);
        }
      };

      // Auto-apply distance: when distance dropdown changes, immediately refresh results
      var _handleDistanceChange = function () {
        if (site.locator.lastSearchContext) {
          var ctx = site.locator.lastSearchContext;
          var newDistance = site.locator.nodes.distanceMenu.val();

          $(document).trigger('loader.start', [site.locator.nodes.container]);
          site.locator.ui.searchBaseHandler(ctx.lat, ctx.lng, newDistance, ctx.country, ctx.intl);
        }
      };

      site.locator.nodes.container
        .off('change.locatorAutoApply')
        .on('change.locatorAutoApply', 'input[name="filter_store_types"]', _handleFilterChange)
        .on('change.locatorAutoApply', 'input[name="filter_product_types"]', _handleFilterChange)
        .on('change.locatorAutoApply', 'input[name="filter_types"]', _handleFilterChange)
        .on('change.locatorAutoApply', 'select.js-distance', _handleDistanceChange);
    }
  };
})(
  jQuery,
  (window.site = window.site || {}),
  (window.generic = window.generic || {}),
  (window.google = window.google || {}),
  (window.addthisevent = window.addthisevent || {}),
  (window.tms_page_data = window.tms_page_data || {})
);
